import { RequisitionListItem } from '../features/requisitions/requisitionSlice'; // Adjust path as needed

export interface StatusInfo {
  statusText: string;
  bgColor: string;
  textColor: string;
  badgeColor: string;
}

export const getStatusDisplay = (requisition: RequisitionListItem | { status_id: number | null, submitted: boolean | number | undefined }): StatusInfo => {
  let statusText = 'Unknown';
  let bgColor = 'bg-gray-200 dark:bg-gray-700';
  let textColor = 'text-gray-800 dark:text-gray-200';
  let badgeColor = 'gray';

  // Handle cases where requisition might be a simpler object for detail page status
  const statusId = requisition.status_id;
  const submitted = typeof requisition.submitted === 'number' ? requisition.submitted !== 0 : requisition.submitted;

  if (!submitted) {
    statusText = 'Not Submitted';
    bgColor = 'bg-gray-400 dark:bg-gray-600';
    textColor = 'text-white dark:text-gray-100';
    badgeColor = 'gray';
  } else {
    switch (statusId) {
      case 1: // Pending
        statusText = 'Pending';
        bgColor = 'bg-yellow-400 dark:bg-yellow-500';
        textColor = 'text-yellow-800 dark:text-yellow-100';
        badgeColor = 'yellow';
        break;
      case 2: // Approved
        statusText = 'Approved';
        bgColor = 'bg-green-500 dark:bg-green-600';
        textColor = 'text-white dark:text-green-100';
        badgeColor = 'green';
        break;
      case 3: // Rejected
        statusText = 'Rejected';
        bgColor = 'bg-red-500 dark:bg-red-600';
        textColor = 'text-white dark:text-red-100';
        badgeColor = 'red';
        break;
      case 4: // Cancelled
        statusText = 'Cancelled';
        bgColor = 'bg-orange-500 dark:bg-orange-600';
        textColor = 'text-white dark:text-orange-100';
        badgeColor = 'orange';
        break;
      default:
        statusText = 'Unknown Status';
        bgColor = 'bg-blue-400 dark:bg-blue-500';
        textColor = 'text-white dark:text-blue-100';
        badgeColor = 'blue';
    }
  }
  return { statusText, bgColor, textColor, badgeColor }; // Added badgeColor for more versatile use
};
